/** @jsxImportSource theme-ui */
import React from 'react';

import * as dto from 'client/dto';
import { formatDateISO, getDatePartStr } from 'utils/dateTimeHelpers';
import { formatNumber } from 'utils/stringFormattingHelpers';

import { Typography } from 'components/_common/Typography';

type TopSituationalUpdateProps = {
  topDescription: dto.DiseaseActivityDescriptionsModel;
  onGoToActivityHistory: (activityDate?: string) => void;
};

export const TopSituationalUpdates: React.FC<TopSituationalUpdateProps> = ({
  topDescription,
  onGoToActivityHistory,
}) => {
  const nMoreSituationalUpdates = topDescription
    ? topDescription.total - (topDescription.descriptions?.length ?? 0)
    : 0;
  const makeReadMoreLink = (dateStr: string, caps: 'capitalize' | false = false) => (
    <span
      sx={{ cursor: 'pointer', textDecoration: 'underline' }}
      onClick={() => onGoToActivityHistory(getDatePartStr(dateStr))}
    >
      {caps ? 'Read more' : 'read more'}
    </span>
  );
  return (
    <>
      {(topDescription.descriptions || []).map(description => (
        <>
          <Typography
            variant="overline"
            color="stone50"
            marginBottom="10px"
            data-testid="reportDate"
          >
            {formatDateISO(description.reportDate)} | {description.locationName}
          </Typography>
          <Typography variant="body2" color="stone90" marginBottom="16px">
            {description.hasHtmlTagsInDescription ? (
              <>
                <div dangerouslySetInnerHTML={{ __html: description.description }} />
                {description.hasBeenTruncated && (
                  <div>{makeReadMoreLink(description.reportDate, 'capitalize')}</div>
                )}
              </>
            ) : (
              <div>
                <span>{description.description}</span>{' '}
                {description.hasBeenTruncated && makeReadMoreLink(description.reportDate)}
              </div>
            )}
          </Typography>
        </>
      ))}
      {nMoreSituationalUpdates > 0 && (
        <a onClick={() => onGoToActivityHistory()} data-testid="TopSituationalUpdates-more-link">
          <Typography variant="body2" color="sea90">
            +{' '}
            {formatNumber(
              nMoreSituationalUpdates,
              'more situational update',
              'more situational updates'
            )}
          </Typography>
        </a>
      )}
    </>
  );
};
